/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 13/11/2013
 * Time: 09:04
 * To change this template use File | Settings | File Templates.
 */



angular.module('FlexyBeautyApp.services').
    factory('Notification_Resource',["$resource","$location", function ($resource,$location){
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl+'rest/notifications/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET' },
            countUnread:   { method: 'GET', url: baseUrl + 'rest/notifications/count-unread' }

        });
    }]);

angular.module('FlexyBeautyApp.services').
    factory('Notification',["NotificationData","Notification_Resource","UserAction", function (NotificationData,Notification_Resource,UserAction){

        var  Notification = function (notificationRes)
        {
            this.id = null;
            this.humanResourceId =null;
            this.status = null;
            this.userActionId = null;
            this.userAction = null;
            this.bookedPlatform = null;
            this.timeCreated = null;

            if (notificationRes!==undefined && notificationRes!=null)
            {
                this.loadObject(notificationRes);
                NotificationData.add(this);
            }
        };
        Notification.prototype.loadObject = function(notificationRes)
        {
            if (notificationRes!==undefined && notificationRes!=null)
            {
                if (!this.id)
                    this.id = notificationRes.id;
                this.humanResourceId = notificationRes.humanResourceId;
                this.userActionId = notificationRes.userActionId;
                this.status = notificationRes.status;
                if (notificationRes.timeCreated)
                    this.timeCreated = new Date(notificationRes.timeCreated);
                if (notificationRes.userAction)
                    this.userAction = new UserAction(notificationRes.userAction,true);
                if (notificationRes.bookedPlatform)
                    this.bookedPlatform = notificationRes.bookedPlatform;
            }
        };
        Notification.prototype.getObjectResource = function()
        {
            var rsNotification = new Notification_Resource();
            rsNotification.id = this.id;
            rsNotification.status = this.status;
            rsNotification.timeCreated = this.timeCreated;
            return rsNotification;
        };


        return  Notification;
    }]);

angular.module('FlexyBeautyApp.services').
    factory('NotificationSrv',["$log","$timeout","Notification","Notification_Resource","NotificationData","UserActionSrv","UserActionManager","ServerSrv","$rootScope","UserAction",
        function ($log,$timeout,Notification,Notification_Resource,NotificationData,UserActionSrv,UserActionManager,ServerSrv,$rootScope,UserAction){
        var notificationSrv = {};

        notificationSrv.query = function(successFunction,errorFunction)
        {
            Notification_Resource.query(
                {},
                function (data) {
                    NotificationData.clear() ;
                    for (let i=0;i < data.length;i++) {
                        new Notification(data[i]);
                    }
                    NotificationData.isLoaded = true;
                    if (successFunction!== undefined) {
                        successFunction(NotificationData.indexNotifications);
                    }
                },
                function (data) {
                    if (errorFunction!== undefined){
                        errorFunction(data);
                    }
                });
        };

        notificationSrv.countUnread = function() {
            let notificationResource = new Notification_Resource();
            return notificationResource.$countUnread();
        };

        notificationSrv.save = function(notification,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(notificationSrv.saveSync, notification, successFunction, errorFunction);
        };
        notificationSrv.saveSync = function(notification,successFunction,errorFunction)
        {
            var NotificationRes = notification.getObjectResource();
            NotificationRes.$save({}, //no params
                function (data) {
                    try{
                        notification.id = data.id;
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        notificationSrv.onNotificationChannel = function(notificationRes) {
            if (notificationRes && notificationRes.userActionId) {
                UserActionSrv.get(notificationRes.userActionId,
                function(userActionRes) {
                    if(NotificationData.isLoaded) {
                        let notification = new Notification(notificationRes);
                        notification.userAction = new UserAction(userActionRes ,true);
                        UserActionManager.executeUserAction(userActionRes ,true);
                        $rootScope.$emit("onNotification", notification);
                    } else {
                        UserActionManager.executeUserAction(userActionRes ,true);
                        $rootScope.$emit("onNotification", null);
                    }
                },
                function() {
                    //TODO
                })
            }
        }

        return notificationSrv;
    }]);

angular.module('FlexyBeautyApp.services').
    factory('NotificationData',["$log", function ($log){
        var notificationData = {
            isLoaded : false,
            indexNotifications: [],
            unreadNotifications: undefined
        }
        notificationData.getById =  function(notificationId)
        {
            for (var i=0;i<this.indexNotifications.length;i++)
                if (this.indexNotifications[i].id==notificationId)
                    return this.indexNotifications[i];
            return null;
        }
        notificationData.getByIndex =  function(index)
        {
            if (index>=0 && index <this.indexNotifications.length)
                return this.indexNotifications[index];
            return null;
        }
        notificationData.getIndexOf =  function(notification)
        {
            if (notification)
                return this.indexNotifications.indexOf(notification);
            return -1;
        }

        notificationData.add =  function(notification)
        {
            if (notification && !notificationData.getById(notification.id))
            {
                this.indexNotifications.push(notification);
            }

        }
        notificationData.clear =  function()
        {
            notificationData.indexNotifications = [];
        }
        return notificationData;
    }]);


// WEBPACK FOOTER //
// ./js/services/models/Notification.js